export const YoutubeRegex =
  /(?:https?:\/\/)?(?:www\.)?youtu(?:\.be\/|be.com\/\S*(?:watch|embed)(?:(?:(?=\/[-a-zA-Z0-9_]{11,}(?!\S))\/)|(?:\S*v=|v\/)))([-a-zA-Z0-9_]{11,})/;

export const URL_REGEX = /^(?:[-A-Za-z0-9]+\.)+[A-Za-z]{2,6}$/;
export const EMAIL_REGEX = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
export const PHONE_REGEX = /^(0[3|5|7|8|9])+([0-9]{8})\b$/;
export const IDENTIFIER_CODE_REGEX = /(^[0-9]{9}$)|(^[0-9]{12}$)/;
export const USERNAME_REGEX = /^[a-zA-Z0-9._-]{3,100}$/;
export const ODER_MAXIMUM = 2147483647;

export const ORDER_VALIDATE = {
  required: "Thứ tự là trường bắt buộc",
  min: {
    value: 0,
    message: "Thứ tự phải lớn hơn 0",
  },
  max: {
    value: ODER_MAXIMUM,
    message: `Thứ tự phải bé hơn 2.147.483.647`,
  },
};

export const EMAIL_VALIDATE = {
  pattern: {
    value: EMAIL_REGEX,
    message: "Địa chỉ email không hợp lệ",
  },
};

export const PHONE_VALIDATE = {
  pattern: {
    value: PHONE_REGEX,
    message: "Số điện thoại không hợp lệ",
  },
};

export const IDENTIFIER_CODE_VALIDATE = {
  pattern: {
    value: IDENTIFIER_CODE_REGEX,
    message: "Mã định danh không hợp lệ (CMND gồm 9 số, CCCD gồm 12 số)",
  },
};

export const USERNAME_VALIDATE = {
  required: "Tên đăng nhập là trường bắt buộc",
  minLength: {
    value: 3,
    message: "Tên đăng nhập phải có ít nhất 3 ký tự",
  },
  maxLength: {
    value: 100,
    message: "Tên đăng nhập không được vượt quá 100 ký tự",
  },
  pattern: {
    value: USERNAME_REGEX,
    message:
      "Tên đăng nhập chỉ được gồm chữ cái, số, dấu châm, dấu gạch dưới hoặc gạch ngang",
  },
};
const PASSWORD_REGEX =
  /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]).{8,50}$/;

export const PASSWORD_VALIDATE = {
  required: "Mật khẩu là trường bắt buộc",
  minLength: {
    value: 8,
    message: "Mật khẩu phải có ít nhất 8 ký tự",
  },
  maxLength: {
    value: 50,
    message: "Mật khẩu không được vượt quá 50 ký tự",
  },
  pattern: {
    value: PASSWORD_REGEX,
    message: "Mật khẩu phải gồm chữ hoa, chữ thường, số và ký tự đặc biệt",
  },
};
export const getConfirmPasswordValidate = (password: string) => ({
  required: "Xác nhận mật khẩu là trường bắt buộc",
  validate: (value: string) =>
    value === password || "Xác nhận mật khẩu không khớp",
});
